<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de veiculo">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-veiculo-create' })"
                    autorize="store-transporte-paciente-veiculo"
                    color="primary"
                >
                    Cadastrar veículo
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/veiculo/List'

export default {
    components: { List },
}
</script>